export default __webpack_public_path__ + "static/media/facebook-icon.e93b77e9.svg";